export const getTimelineItemLabel = (linkText: string, heading?: string) => {
    return heading ? `${heading} ${linkText}` : linkText;
};
